module.exports = __webpack_public_path__ + "img/slide-5.b1148948.png";